export const SET_ERROR = 'SET_ERROR';
export const RESET_STATE = 'RESET_STATE';
